// extracted by mini-css-extract-plugin
export default {"property":"BranchSummary_property__fzCKC","icon":"BranchSummary_icon__CklUp","content":"BranchSummary_content__9Or3C"};